

export default class QbOperations {
  
  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }
  
  contains(name) {
    if (name) {
      //
    }
    return false;
  }
  
  list(params) {
    var event = new QbOperations.List.Operation(params);
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }

  static List = {
    Names: {
      Operation: 'QbCardListCommandOperation',
      Notification: 'QbCardListNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function(params) {
      var event = {
        handler: QbOperations.List.Names.Operation,
        eventName: QbOperations.List.Names.Operation,
      }
      
      event["Params"] = params.data ? params.data : params;

      return event;
    },
  }

}